import { UserCommunication } from '@this+that/models';

interface WithLastMessage {
  lastMessage?: UserCommunication;
}

export const sortByLastMessage = <T extends WithLastMessage>(
  a: T,
  b: T,
): number => {
  if (!a.lastMessage && !b.lastMessage) return 0;
  if (!a.lastMessage) return 1;
  if (!b.lastMessage) return -1;
  return b.lastMessage.createdAt - a.lastMessage.createdAt;
};
